// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".suggestions-list{list-style-type:none;padding-left:0.5rem;border:1px solid black;position:absolute !important;background-color:white;top:2rem;left:1rem;z-index:2}.suggestion-item{text-decoration:underline;font-weight:bold;cursor:pointer;float:left;display:flex}\n", ""]);
// Exports
module.exports = exports;
